<template>
	<div class=" qualityenterprise">
		<leftnav class="fl" mkcode="A" itemcode="A-LYSZDT">
		</leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div class="heightVh95 whitebox container-flex-center">
					<freeUserTips :type="4" :bgtype="0" isShowPageTitle="全部楼宇"></freeUserTips>
				</div> 
			</div>
		</div>
	</div>
</template>

<script>
import BGMap from '../enterpriseInc/bgmap.vue';
import EnterpriseDetail from '../enterpriseInc/enterprise-detail';
import CitySelector from '../enterpriseInc/city-selector';
import notify from '../../utils/notify';
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'buildingmapsearch',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			userdata: {},
			// mapurl: '',
			time: '',
			title: "地图搜索",
			areaData: [],
			countyData: [{ county: 0, countyName: "全深圳" }],
			areaId: 0,
			streetData: [],
			streetId: 0,
			countyid: 0,
			currentcity: {
				type: "city", id: 4301
			},
			curWebsite: this.$api.getWebsiteType(),
			searchtext: "",
			kwtextsearch: false,
			kwtextsearchtext: "",
			page: 1, //显示的是哪一页 
			pageSize: 10, //每一页显示的数据条数
			total: 0, //记录总数
			totalPage: 1,
			maxPage: 10, //最大页数   
			//地图相关参数
			mapUtil: null,
			position: [],
			userInfo: {},
			showViewbar: false,
			list: [],
			viewList: [],
			mapPageList: [],
			mapPage: 1,
			mapPageSize: 10,
			mapTotal: 1,
			selectItem: {},
			selectPixel: null,
			showDetail: false,
			showCitySelect: false,
			driving: null,
			isLoadNet: false,
			isSatellite: false,
			searchWord: '',
			showSearch: true,
			showSearchResult: false,
			searchList: [],
			searchTimerId: 0,
			//item.longitude,item.latitude
			cityLand: [114.08594700, 22.54700000],
			onloadbtn: true,
			// areadata: dataInJs(),
		}
	},
	components: {
		BGMap,
		EnterpriseDetail,
		CitySelector
	},
	created() {
		// this.$nextTick(() => {
		// 	// 禁用右键
		// 	document.oncontextmenu = new Function("event.returnValue=false");
		// 	// 禁用选择
		// 	document.onselectstart = new Function("event.returnValue=false");
		// });

		// this.userdata = this.getuseriformation();
	},
	mounted() {
		// document.getElementById('app').style.background = "#f0f3f5";
		// this.getStreetData();
		// this.mapUtil = this.$refs.bgmap.getMapUtil();
	},
	methods: {
		//筛选区域
		//位置区域选择选择
		areaChoosed(item) {
			this.countyid = item.county;
			this.streetData = this.areaData.filter(list => {
				return list.county == item.county;
			});
			this.streetChoosed({ id: 0 });
			this.areaName = item.areaName;
		},
		streetChoosed(list) {
			this.streetId = list.id;
			this.loadData();
		},
		getStreetData() {
			var ajaxurl = this.$api.park.building.areaList();
			var _this = this;
			console.log(ajaxurl, this.userdata.token)
			// console.log(ajaxurl)
			this.$axios.get(ajaxurl, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				console.log(res.data.list)
				_this.areaData = res.data.list;
				let str = "", data = res.data.list;
				for (var i = 0; i < data.length; i++) {
					if (str.indexOf(data[i].countyName) < 0) {
						str += data[i].countyName;
						_this.countyData.push({ countyName: data[i].countyName, county: data[i].county })
					}
				}
				_this.streetData = [];
				// _this.loadData();
			}).catch(function (error) { });

		},
		//招商地图map相关  页面筛选数据函数
		loadData(type) {
			this.bus.$emit('loading', true);
			//this.$api.cyl.map.enterpriseList() 企业招商地图的
			var ajaxurl = this.$api.park.building.list() + '?pageSize=5000&map=1&county=' + this.countyid + '&area=' + this.streetId;
			var _this = this;
			this.$axios.get(ajaxurl, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(res => {
				var data = res.data;
				_this.list = res.data.list || [];
				console.log('筛选', ajaxurl, _this.list);
				for (var i = 0; i < _this.list.length; i++) {
					_this.list[i].type = 1;
				}
				if (_this.list.length > 0) {
					if (_this.countyid != 0) {
						_this.cityLand = [_this.list[0].lng, _this.list[0].lat];
					} else {
						_this.cityLand = [114.08594700, 22.54700000];
					}
				}
				_this.mapUtil.moveTo(_this.cityLand);
				_this.setViewList();
				_this.bus.$emit('loading', false);
			});
		},
		onLocation({ position, area }) {
			console.log('index1', position, area);
			this.position = position; //旧版location 已暂停 
			this.loadData();
			// this.mapUtil.setZoomAndCenter(14, position);
			// //获取用户信息和公司信息  
			// var ajaxurl = this.$api.cyl.map.entlistbycity() + '?area=' + area;
			// var _this=this;

			// this.$axios.get(ajaxurl, {
			// 	headers: {
			// 		AuthToken: this.userdata.token
			// 	}
			// }).then(res => { 
			// 	var data = res.data;
			// 	var userInfo = {
			// 		...data.data,
			// 		total: data.totalRecord
			// 	};
			// 	var list = data.list; 
			// 	_this.userInfo = userInfo;
			// 	_this.areaName = userInfo.areaName;
			// 	_this.areaId = userInfo.city;
			// 	_this.list = list ? list : [];
			// 	console.log('初始化',this.list)
			// 	_this.setViewList();
			// });
		},
		onSelectCity(city) {
			if (city.id != this.areaId) {
				this.areaId = city.id;
				this.areaName = city.name;
				this.mapUtil.setCity(city.name, city);
				this.loadData(city.id);
			}
			this.showCitySelect = false;
		},
		onZoomChange(zoom) {
			this.setViewList();
			// if(this.showDetail){
			//     this.selectedPixel = this.$refs.bgmap.refreshMap(this.selectItem);
			// }
		},
		onMapMove(center) {
			this.setViewList();
		},
		onCloseEnterpriseDetail() {
			this.showDetail = false;
			this.selectItem = {};
			this.selectPixel = {};
		},
		onSelectItem(data) {
			if (data.id != this.selectItem.id) {
				this.mapUtil.moveTo([data.lng, data.lat]);
				this.selectItem = data;
				this.showDetail = true;
				this.selectPixel = this.$refs.bgmap.showSelectItem(data);
			}
		},
		onNavigation(type) {
			console.log('navigation', type);
			this.driving = this.mapUtil.navigation({
				type,
				from: this.position,
				to: [this.selectItem.lng, this.selectItem.lat],
				city: this.areaName,
				panel: 'navigationPanel',
				callback: success => {
					this.$refs.detail.onNavigationComplete(success);
				}
			});
		},
		onNavigationClose() {
			if (this.driving) {
				this.driving.clear();
			}
		},
		toggleViewbar() {
			this.showViewbar = !this.showViewbar;
		},
		setViewList() {
			if (!this.list || this.length == 0 || this.showSearchResult) {
				return;
			}
			//var mapUtil = this.$refs.bgmap.getMapUtil();
			this.viewList = this.mapUtil.getViewList(this.list);
			this.$refs.bgmap.setData(this.viewList);
			this.changePage(1);
			this.mapTotal = this.viewList.length;
		},
		setSearchList() {
			this.$refs.bgmap.setSearchData(this.searchList);
		},
		setUserPosition() {
			this.mapUtil.moveTo(this.position);
		},
		changePage(page) {
			this.mapPage = page;
			var start = (page - 1) * this.mapPageSize;
			var end = start + this.mapPageSize;
			this.mapPageList = this.viewList.filter((o, i) => i >= start && i < end);
			//console.log(this.pageList);
		},
		toggleLoadNet() {
			this.isLoadNet = !this.isLoadNet;
			if (this.isLoadNet) {
				this.mapUtil.addLoadNet();
			} else {
				this.mapUtil.removeLoadNet();
			}
		},
		toggleSetallite() {
			this.isSatellite = !this.isSatellite;
			if (this.isSatellite) {
				this.mapUtil.addSatellite();
			} else {
				this.mapUtil.removeSatellite();
			}
		},
		enterSearchIcon() {
			//console.log('enter');
			this.showSearch = true;
			setTimeout(() => {
				this.$refs.elSearch.focus();
			}, 500);
		},
		leaveSearchIcon() {
			//console.log('leave');
			this.showSearch = this.showSearchResult || false;
		},
		searchEnterprise(kw) {
			clearTimeout(this.searchTimerId);
			this.showSearchResult = this.searchWord != '';
			if (this.showSearchResult) {
				// this.searchList = this.list.filter(x => x.title.indexOf(kw) >= 0);
				this.bus.$emit('loading', true);
				var ajaxurl = this.$api.park.building.list() + '?pageSize=5000&map=1&county=0&area=0&kw=' + this.searchWord,
					_this = this;
				this.getAxiosData(ajaxurl, this.userdata.token, function (res) {

					_this.searchList = res.list;
					_this.bus.$emit('loading', false);
				})


			} else {
				this.searchList = [];
			}
			this.searchTimerId = setTimeout(_ => {
				this.setSearchList();
			}, 1000);
		},
		formatSearchTitle(title) {
			return title.replace(this.searchWord, '<span class="redfont">' + this.searchWord + '</span>');
		},
		closeSearchBar() {
			this.showSearch = false;
			this.showSearchResult = false;
			this.searchWord = '';
			this.searchList = [];
			this.setViewList();
		},
		//地图相关结束
		//搜索关键词
		searchkwfun() {
			this.searchtext = $.trim(this.searchtext);
			// if(this.searchtext!="" || ){
			this.ajaxsearchcompany(1, 'srot', 'search');
			// } 
		},
		searchenter(e) {
			if (e.keyCode == 13) {
				this.searchkwfun();
			}
		},
		getCurrentTime() {
			//获取当前时间
			var _this = this;
			let yy = new Date().getFullYear();
			let mm = new Date().getMonth() + 1;
			let dd = new Date().getDate();
			let hh = new Date().getHours();
			let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
			let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
			// 　　_this.gettime = yy+'/'+mm+'/'+dd+' '+hh+':'+mf+':'+ss; 
			this.time = yy + '-' + mm + '-' + dd + ' ';
		},
	},
}
</script>

<style>
/* @import "../../../css/index.css"; */



/* 	.mapserch_mapbox{
		width: 100%;
		height: 40%;
		border: 1px solid red;
	} */
</style>
<style lang="scss" scoped>
.box-shadow {
	background: #fff;
	border-radius: 4px;
	box-shadow: 0 0 8px rgba(0, 0, 0, .1);
}

body .el-card__header {
	padding: 13px 20px;
}

body .fade-enter-active {
	transition: width 2s;
}

body .word {
	color: #c00;
	font-weight: bold;
}

.sider-left {
	position: absolute;
	left: 20px;
	top: 20px;
	font-size: 14px;
	text-align: left;
	width: 380px;
	color: #000;
}

.area-bar {
	padding: 10px;
	position: relative;

	.count {
		margin: 0 10px;
	}

	.search-icon {
		float: right;
		margin-top: 7px;
		margin-right: 6px;
		font-size: 18px;

		&:hover {
			color: #39f;
		}
	}

	.el-icon-close {
		font-size: 18px;
	}

	.el-input__icon.el-icon-search {
		width: 18px;
		color: #5E83CC;
	}

	.search-bar {
		position: absolute;
		left: 0;
		top: 0;
		width: 98%;
		height: 100%;

		//display:none;
		.search-text {
			margin: 5px 4px;
			width: 300px;
		}

		.search-btn {
			width: 60px;
			color: #5E83CC;

		}

	}
}

.num,
.kw {
	color: rgb(16, 111, 189);
	font-weight: bold;
	margin: 0 8px;
}

.tool-bar {
	position: absolute;
	top: 20px;
	right: 20px;
	text-align: left;

	.btn-me {
		color: #c00;
		margin-right: 20px;
		padding: 3px;
		font-size: 22px;

		i {
			font-size: 24px;
		}

		&:hover {
			background: #e4f1ff;
			color: #f00;
		}
	}
}
</style>
<style scoped lang="scss">
#testmap {
	position: relative;
	width: 95%;
	margin: 0 auto 20px;
	// width: 100%;position: relative;
	overflow-y: hidden;
	overflow: hidden;
	height: 93.6vh;
}

.kw {
	color: #c00;
}

.el-icon-arrow-up {
	transition-duration: 0.2s;
}

.arrow-active {
	transform: rotate(180deg);
	transition-duration: 0.2s;
}

.view-bar {
	margin-top: 12px;
	position: relative;

	.box-card {
		.header {
			padding: 15px 20px;
		}

		.cont {
			padding: 5px 0;
			border-top: 1px solid #eee;
			height: 600px;
			overflow-y: scroll;

			.item {
				cursor: default;
				padding: 0 20px;
			}

			.active {
				background: #eee;

				.title {
					color: #f50;
				}
			}
		}

		.title {
			font-size: 16px;
			padding: 10px 0;
			font-weight: bold;
			color: rgba(9, 22, 49, 0.842);
		}

		.addr {
			font-size: 12px;
			color: #555;
			border-bottom: 1px solid #eee;
			padding: 5px 0 10px;
		}
	}

	.pagination {
		padding: 10px 0;
	}
}</style>
